export default __webpack_public_path__ + "9702a2436e1b2c1d682e29e5d1ecfdac.svg";